import { render, staticRenderFns } from "./BannersDesktop.vue?vue&type=template&id=2feb8c1c&"
import script from "./BannersDesktop.vue?vue&type=script&lang=js&"
export * from "./BannersDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports